import {Injectable} from '@angular/core';
import {BoundingBox} from "../../services/pharmacy-locator/models/BoundingBox";

@Injectable()
export class PharmacyLookupServiceInterface {
    getBySquare = (boundingBox: BoundingBox) => null;
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/pharmacy-lookup/pharmacy-lookup-service-interface.service.ts